module.exports = __webpack_public_path__ + "static/media/6.1.74ec6a84.zip";